import {createAction, props} from '@ngrx/store';
import {ManageOrganization, Organization} from '../../../services/api/organizations/models/organization.model';

export const createOrganization = createAction(
  '[CreateOrganization] Create Organization',
  props<{ data: ManageOrganization }>()
);

export const createOrganizationSuccess = createAction(
  '[CreateOrganization] Create Organization Success',
  props<{ data: Organization }>()
);

export const createOrganizationFailure = createAction(
  '[CreateOrganization] Create Organization Failure',
  props<{ error: any }>()
);

export const clearCreateOrganizationState = createAction(
  '[CreateOrganization] Clear Create Organization State'
);
